(() => {
  function bindPartnersSizing(scope) {
    scope.querySelectorAll('.knox-partners-meganav').forEach(menu => {
      const wrapper = menu.querySelector('.knox-partners-meganav__wrapper');
      const item = menu.closest('[data-navmenu-meganav-trigger]');
      if (!wrapper || !item || menu.dataset.knoxPartnersSizing) return;
      menu.dataset.knoxPartnersSizing = 'true';
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(() => {
          const height = Math.ceil(wrapper.getBoundingClientRect().height);
          if (height > 0) item.style.setProperty('--menu-open-height', `${height}px`);
        });
        observer.observe(wrapper);
      }
    });
  }
  bindPartnersSizing(document);
  document.addEventListener('shopify:section:load', event => {
    bindPartnersSizing(event.target);
  });
})();

